import {StoryTool} from "../StoryTool";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFilePen, faHammer} from "@fortawesome/free-solid-svg-icons";
import {StoryCrafterContent} from "./StoryCrafterContent";

export class StoryCrafter implements StoryTool {
    id = 'story-crafter'
    name = "Story Crafter"
    paths = [
        `/projects/:projectId/stories/:storyId/${this.id}`,
        `/projects/:projectId/stories/:storyId/${this.id}/:draftTab`
    ]
    enabled = true
    icon = <FontAwesomeIcon icon={faFilePen}/>
    entryPoint = <StoryCrafterContent/>
    link = (projectId?: string, storyId?: string) => `/projects/${projectId}/stories/${storyId}/${this.id}`
}